/* English dictionary: menu namespace. See src/i18n/README.md. */

import type { TextSpec } from '../text';

const menu = {
  // ---- Title screen ----
  'title.header': [ 'ACID SAMIZDAT' ],
  'title.netplay': [ 'Online Match' ],
  'title.hotseat': [ 'Local Match (Hotseat)' ],
  'title.debug': [ 'Debug Page' ],

  // ---- Changelog page (entered above the Credits button on the title screen) ----
  'changelog.framework': [ 'Core Framework' ],
  'changelog.loreRichText': [ 'Structured Text System' ],
  'changelog.platformAdaptation': [ 'Multi-platform Support' ],

  // ---- Netplay meetup ----
  'meetup.roomCode': [ 'Room code (', { type: 'param', name: 'n' }, ' digits)' ],
  'meetup.join': [ 'Join' ],
  'meetup.changeNickname': [ 'Change nickname in Settings' ],

  // ---- Connecting screen ----
  'connecting.header': [ 'Connecting' ],
  'connecting.joinPanel': [ 'Join Room' ],
  'connecting.roomCode': [ 'Room code ', { type: 'param', name: 'code' } ],
  'connecting.probing': [ 'Connecting to the signaling network…' ],
  'connecting.searching': [ 'Looking for the room…' ],
  'connecting.ready': [ 'Connected' ],
  'connecting.failed': [ 'Connection failed' ],
  'connecting.idle': [ 'Not connected' ],
  'connecting.returning': [ 'Returning' ],
  'connecting.cancel': [ 'Cancel' ],

  // ---- In-game bottom-right button ----
  'table.agree': [ 'Agree' ],
  'table.giveUp': [ 'Give Up' ],
  'table.endExtraTurn': [ 'End Extra Turn' ],
  // ---- Center-of-screen play choice (target / target + card) ----
  'table.chooseTarget': [ 'Choose a target' ],
  'table.chooseTargetAndName': [ 'Choose a target and a card' ],

  // ---- Action-button hover tips (what pressing it does) ----
  'table.endTurn.common': [ 'Draw a card and end the turn.' ],
  'table.endTurn.tip': [
    { type: 'key', key: 'table.endTurn.common' },
    '\nThe turn then passes to the next player.',
  ],
  'table.endExtraTurn.tip': [
    { type: 'key', key: 'table.endTurn.common' },
    'Because of ',
    { type: 'param', name: 'card' },
    ' from another player, ',
    { type: 'param', name: 'count' },
    ' more turns are required.\n',
  ],
  'table.agree.tip': [ 'Forgo the interrupt and hand over ', { type: 'param', name: 'card' } ],
  'table.giveUp.tip': [ 'Forgo the rescue and concede the game.' ],

  // ---- File export ----
  'transfer.unsupported': [ 'Export is not supported in this environment' ],
  'transfer.failed': [ 'Export failed' ],

  // ---- Room preset import ----
  'preset.invalidJson': [ 'Failed to parse the data; the file may be corrupted.' ],
  'preset.wrongKind': [ 'No room configuration data found in the file.' ],
  'preset.tooNew': [ 'This configuration comes from a newer game version. Please refresh the page.' ],

  // ---- Connect / session ----
  'connect.offline': [ 'Cannot connect to the network.' ],
  'connect.relayUnreachable': [ 'Cannot connect to a signaling relay.' ],
  'connect.roomNotFound': [ 'Room not found.' ],
  'connect.networkUnreachable': [ 'Cannot connect to the network.' ],
  'session.kicked': [ 'Removed from the room by the host.' ],
  'session.notInRoom': [ 'Not in a room.' ],

  // ---- Entry point ----
  'main.rendererFatal': [
    'Unable to render.\n',
    'Your browser or device does not support the rendering technology used by this game.',
  ],
  'main.rotateHint': [ 'Please rotate your device' ],
  // ---- developer diagnostics ----
  'main.logRelayProbeFailed': [ '[s3] relay probe failed: room' ],
  'main.logRelayConfigured': [ '[s3] signaling relays (configured):' ],
  'main.logActualSocket': [ '\n[s3] actual sockets:' ],
  'main.logNoPeer': [ '[s3] no peer found. local relays:' ],
  'main.logTurnConfigured': [ '[s3] TURN configured:' ],
  'main.logTurnFailed': [ '[s3] TURN credentials failed; using STUN only:' ],
  'main.logBgmStartFailed': [ '[bgm] failed to start:' ],
  'screenHost.unknownScreen': [ 'No screen registered under the id: ', { type: 'param', name: 'id' }, '.' ],
  'screenHost.unknownScreenHint': [ 'Screen factories must be define()d before start() (see ScreenHost.start).' ],
  'stack.empty': [ 'The menu stack is empty - the root screen must not be popped' ],
  'beat.subscriberThrew': [ '[beat] a music-event subscriber threw' ],
} as const;

// 静态检查（写在对象字面量之外，避免 TextKey 循环推断）
menu satisfies Record<string, TextSpec>;
export default menu;
